import React, { useState, useEffect } from "react"
import { auth } from "../firebase"
import Layout from "../layout"
import Login from "../pages/login/login"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import RoutesBuilder from "../router"
import { UserProvider } from "../context/usercontext"
import Register from "../pages/login/register"
import { ProgressSpinner } from "primereact/progressspinner"

function App() {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (authUser) => {
      if (authUser) {
        try {
          if (!authUser.emailVerified) {
            setUser(null)
            return
          }
          await authUser.getIdToken(true)
          setUser(authUser)
        } catch (error) {
          console.error("Error al renovar el token:", error)
          setUser(null)
        }
      } else {
        setUser(null)
      }
      setLoading(false)
    })
    return () => unsubscribe()
  }, [])

  if (loading) {
    return (
      <div
        className="flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <ProgressSpinner />
      </div>
    )
  }

  return (
    <UserProvider>
      <Router>
        {user && user.emailVerified ? (
          <Layout>
            <RoutesBuilder />
          </Layout>
        ) : (
          <Routes>
            <Route path="/register" element={<Register />} />
            <Route path="/register/:code" element={<Register />} />
            <Route path="*" element={<Login />} />
          </Routes>
        )}
      </Router>
    </UserProvider>
  )
}

export default App
